import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { RootReducerState } from 'reduxStore/rootReducers';
import { getMerchantList, getMerchantOfferList, getOfferList } from 'reduxStore/actions';
import { IoFilter } from 'react-icons/io5';
import { CSSTransition } from 'react-transition-group';
import { loadable } from 'react-lazily/loadable';
const Filter = lazy(() => import('pages/offers/Filter'));
const { Offerscard } = loadable(() => import('components/cards'), {
fallback: <>Loading...</>,
});

interface IndexComponentProps {}

const Index: React.FunctionComponent<IndexComponentProps> = (props): JSX.Element => {
	const dispatch = useDispatch();
	const { loading, error, merchantOfferData, merchantList } = useSelector(
		({ merchantReducer }: RootReducerState) => ({
			loading: merchantReducer.merchantOfferData.loading,
			error: merchantReducer.merchantOfferData.error,
			merchantOfferData: merchantReducer.merchantOfferData.data,
			merchantList: merchantReducer.merchantData.data,
		}),
		shallowEqual
	);

	const [toggleFilter, setToggleFilter] = useState(false);

	const handleFilter = (data: any) => {
		dispatch(getMerchantOfferList(data));
	};
	useEffect(() => {
		dispatch(getOfferList());
		dispatch(
			getMerchantList({
				category_id: 'all',
				district_id: 'all',
				province_id: 'all',
			})
		);
	}, []);

	return (
		<section className="product-card-section offer-section">
			<div className="container">
				{/* HEADER FILTER */}
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: `${toggleFilter ? 'space-between' : 'right'}`, textAlign: 'left' }}>
					<CSSTransition in={toggleFilter} timeout={300} classNames="" unmountOnExit>
					<Suspense fallback={<div>Loading...</div>}><Filter handleFilter={handleFilter} /></Suspense>
					</CSSTransition>
					<div className="mx-1" style={{ textAlign: 'right', marginTop: 20, marginBottom: 20 }}>
						<button className="btn btn-outline-success" type="button" onClick={() => setToggleFilter((prev) => !prev)}>
							<IoFilter />
						</button>
					</div>
				</div>
				{/* <NetworkStatus
					loading={loading}
					error={error}
					hasData={merchantOfferData.length}
				/> */}
				{merchantOfferData.length <= 0 && (
					<>
						<h4 className="text-center my-5 text-success">
							There is no ongoing offer at the moment.
							<br />
							Please visit later.
						</h4>
					</>
				)}

				<div className="row">
					{merchantOfferData.map((item: any, index: number) => (
						<div className="col-lg-3 col-md-6 mb-4" key={index}>
							<Offerscard merchantList={merchantList} {...item} />{' '}

						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Index;
